interface Props {
  width?: number;
  height?: number;
  hexColor?: string;
  strokeWidth?: number; 
  slimmer?: boolean;
}

export const ArrowDown = ({
  width = 20,
  height = 20,
  hexColor = "#e2e2e2",
  strokeWidth = 1,
  slimmer = false
}: Props) => {
  return (
    !slimmer
    ?
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 7.9L0 1.9L1.4 0.5L6 5.1L10.6 0.5L12 1.9L6 7.9Z"
        // stroke={hexColor}
        // strokeWidth={strokeWidth}
        // strokeLinecap="round"
        // strokeLinejoin="round"
        fill={hexColor}
      />
    </svg>
    :
    <svg width={width} height={height} viewBox="0 0 19 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 1.414L15.293 16.707L0 32L1.414 33.414L18.121 16.707L1.414 0L0 1.414Z" fill={hexColor} />
    </svg>

  );
};

export default ArrowDown;
